import { render, staticRenderFns } from "./bgaChangeListAction.vue?vue&type=template&id=88155a10&scoped=true"
import script from "./bgaChangeListAction.vue?vue&type=script&lang=js"
export * from "./bgaChangeListAction.vue?vue&type=script&lang=js"
import style0 from "./bgaChangeListAction.vue?vue&type=style&index=0&id=88155a10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88155a10",
  null
  
)

export default component.exports